import React from 'react';
import PropTypes from 'prop-types';

import Modal from '../../components/Modal';
import ModalHeader from '../../components/ModalHeader';
import ModalButtons from '../../components/ModalButtons';
import InlineSection from '../../../components/InlineSection';
import { ContainedButton } from '../../../components/Buttons';
import { propTypes as i18nPropTypes } from '../../../hocs/intlEquipped';
import { orResolver } from '../../../util/helpers';
import { triggerSurvey } from '../../../util/interate';

const getPaymentInfoText = payment => orResolver({})([
    [payment?.nextBilling?.date && payment?.nextBilling?.price, () => 'remainingPayments'],
    [['Free', 'NoMore'].includes(payment?.nextBilling?.lackReason), () => 'noRemainingPayments'],
    [payment?.nextBilling?.lackReason === 'TooFarAhead', () => 'noCalculatedPayments'],
]);

const CancelSubscriptionConfirmationModal =
    ({ onClose, subscriptionData, theme, showModal, i18n: { formatMessage, formatDate } }) => {
        const { product, payment } = subscriptionData;
        const remainingPaymentsId = getPaymentInfoText(payment);
        const onCloseWithSurvey = () => {
            onClose();
            triggerSurvey({ surveyId: CONFIG.myPage.surveys?.cancellationFeedback });
        };

        return (
            <Modal
                theme={ theme }
                open={ showModal }
                onClose={ onCloseWithSurvey }
            >
                <ModalHeader
                    title={ formatMessage('modals.cancelSubscription.confirm.header') }
                    onClose={ onCloseWithSurvey }
                />
                <div className={ theme.cancelSubscriptionConfirmationModal }>
                    {product && (
                        <InlineSection
                            theme={ theme }
                            icon={{
                                name: 'play-circle',
                                className: 'playIcon',
                            }}
                            mainContent={ formatMessage('modals.cancelSubscription.confirm.activeSection') }
                            subContent={ formatDate(product.expires) }
                        />
                    )}
                    {payment && (
                        <InlineSection
                            theme={ theme }
                            icon={{
                                name: 'payment',
                            }}
                            mainContent={ formatMessage(`modals.cancelSubscription.confirm.${remainingPaymentsId}`) }
                        />
                    )}
                    <InlineSection
                        theme={ theme }
                        icon={{
                            name: 'streamline/info',
                            className: 'infoIcon',
                        }}
                        mainContent={ formatMessage('modals.cancelSubscription.confirm.wontRenewAfterExpiration') }
                    />
                    <ModalButtons>
                        <ContainedButton
                            text={ formatMessage('modals.cancelSubscription.buttons.ok') }
                            onClick={ onCloseWithSurvey }
                            testId="cancelSubscriptionConfirmationModalBtn"
                        />
                    </ModalButtons>
                </div>
            </Modal>
        );
    };

CancelSubscriptionConfirmationModal.propTypes = {
    onClose: PropTypes.func.isRequired,
    subscriptionData: PropTypes.shape({
        source: PropTypes.string,
        product: PropTypes.shape({
            expires: PropTypes.string,
        }),
        payment: PropTypes.shape({
            nextBilling: PropTypes.shape({
                date: PropTypes.string,
                price: PropTypes.number,
                lackReason: PropTypes.string,
            }),
        }),
    }),
    theme: PropTypes.shape({}),
    intl: PropTypes.shape({}).isRequired,
    showModal: PropTypes.bool.isRequired,
    i18n: i18nPropTypes,
};

CancelSubscriptionConfirmationModal.defaultProps = {
    subscriptionData: {
        product: null,
        payment: null,
    },
};

export default CancelSubscriptionConfirmationModal;
